const {jQuery: $} = window;
import Cookies from 'js-cookie';
import FancyAccordion from "./fancy_accordions";
import Utils from "./utils.class";


export default class Theme {
    #$PB;
    #$main;
    #$html;
    #$body;
    #$header;
    #$admin;
    #builder;
    #utils;
    #nav;
    #tabbedNav;
    #slider;
    #config;
    #counter;
    #scrollOffset;
    #scrollSpeed;
    #FancyAccordion
    #root;

    constructor(
        config,
        builder,
        utils,
        nav,
        slider,
        tabbedNav
    ) {
        this.#root = document.querySelector(":root");
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#nav = nav;
        this.#tabbedNav = tabbedNav;
        this.#slider = slider
        this.#$PB = this.#builder.jQuery;
        this.#$html = $('html');
        this.#$body = $('body');
        this.#$header = $('.site_header');
        this.#$main = $('.site-wrapper');
        this.#$admin = $('#wpadminbar');
        this.#FancyAccordion = new FancyAccordion(this);

        this.#counter = $('.counter__number');

        this.#scrollOffset = 0;
        this.#scrollSpeed = 750;

        if (window.location.hash === "#dev") {
            Cookies.set("debug", 1);
        }
    }

    __onReady() {
        const me = this;
        Utils.log("Theme Ready");
        this.#nav.events();
        this.#slider.setup();
        this.#tabbedNav.events();

        me.#FancyAccordion.events();

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.headerHeight + me.#scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').on('click', function (e) {
            let $el = $(this);

            if ($el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (!Utils.scrollToHash(hash, null, me.headerHeight + me.#scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        this.#slider.show();
        this.#utils.equalHeight('.image_callout__text', '.builder-layout');
        this.#utils.equalHeight('.js-equalizer-logo', '.logo-slider-container');
        this.#utils.equalHeight('.info_block__js', '.info_block');
        this.#utils.equalHeight('.feature_card__title--spacer', '.builder-layout');
        this.#utils.equalHeight('.feature_card__subtitle--spacer', '.builder-layout');
        this.#utils.equalHeight('.feature_card__blurb--spacer', '.builder-layout');

        this.#utils.equalHeight('.single-slide__left', '.slick-track');

        function counter(el) {
            let $me = $(el),
                time = ($me.attr('data-time') || 3000) * 1000,
                countTo = $me.attr('data-count'),
                delay = ($me.attr('data-delay') || 0) * 1000;

            setTimeout(function () {
                $({
                    countNum: 0
                }).animate({
                        countNum: countTo
                    },

                    {
                        duration: 3000,
                        easing: 'linear',
                        step: function () {
                            $me.text(me.#utils.commaSeparateNumber(Math.floor(this.countNum)));
                        },
                        complete: function () {
                            $me.text(me.#utils.commaSeparateNumber(this.countNum));
                        }
                    }
                );
            }, delay);
        }

        this.#counter.each(function (i, el) {

            $(el).on('animationTrigger', function () {
                counter(el);
            });

            $(el).data('waypoint', new Waypoint.Inview({
                element: el,
                entered: function (dir) {
                    if ($(el).parents('.animation-trigger').length == 0) {
                        counter(el);
                    }
                },
                exited: function (dir) {

                }
            }));
        });


        if (location.hash) {
            Utils.log("Scroll to Section Load");

            setTimeout(function () {
                Utils.scrollToHash(location.hash, null, me.headerHeight + me.#scrollOffset, me.#scrollSpeed);

            }, 300);
        }

        $(document).scroll(function () {

            let $scrollPos = $(document).scrollTop();
            if ($scrollPos > 0) {
                $('.site_header').addClass('scroll_check');
            } else if ($scrollPos <= 0) {
                $('.site_header').removeClass('scroll_check');
            }
        });

        this.#$header.addClass('fixed');


        $('.single_accordion .single_accordion__header').on('click', function () {
            var $column = $(this).parent();

            $column.toggleClass('open');
            $column.find('.single_accordion__inner').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        this.#updateCssHeaderHeight();
    }

    __onResize() {
        const me = this;

        this.#utils.equalHeight('.info_block__js', '.info_block');
        this.#updateCssHeaderHeight();
    }

    /**
     * @param {PostFilters} kpf
     * @private
     */
    __postFilters(kpf) {
        Utils.log("Theme customizations for Post Filters...");

        if(this.#$body.hasClass("search-results")) {
            kpf.addAction("get_posts_success", function(response, settings) {
                let searchText = window.location.protocol + "//" + window.location.hostname + window.location.pathname + "?s=" + (settings.searchQuery || " ");
                history.replaceState(history.state, "", searchText.toString());
            });
        }

        kpf.addFilter("select2_options", function (options) {
            options.dropdownParent = $(".main-wrapper");

            return options;
        });

        kpf.$el.filter(".kpf-slider-mode").each(function (i, el) {
            const $el = $(el);
            const slick = kpf.data($el, "slick");
            Utils.log($el, slick)
            $el.find(".kpfsc__posts").slick(slick);
        });
    }


    get utils() {
        return this.#utils;
    }

    get headerHeight() {
        if (this.#$admin.length > 0) {
            return this.#$header.outerHeight() + this.#$admin.outerHeight();
        }

        return this.#$header.outerHeight();
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
        Utils.log('update css header height')
    }
}